import { render, staticRenderFns } from "./PortalModal.vue?vue&type=template&id=f08e413c"
import script from "./PortalModal.vue?vue&type=script&lang=js"
export * from "./PortalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports